import users from './users';
import { exams } from './exams';

export const getTeacherMenuItems = () => {
  return {
    items: [users, exams]
  };
};
